import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { applyUpdate, onUpdateAvailable } from "@/lib/pwa/register";

/**
 * The other half of the update handshake in `lib/pwa/register.ts`.
 *
 * The worker never calls `skipWaiting()` on its own, so a new build cannot
 * swap the asset set under a mounted tree and blow up the next lazy import.
 * It waits here until someone says yes.
 */
export function UpdateToast() {
  const [ready, setReady] = useState(false);

  useEffect(() => onUpdateAvailable(() => setReady(true)), []);

  if (!ready) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-3 z-50 rounded-xl border border-border bg-bg-elevated p-3 shadow-xl"
      style={{ bottom: "calc(1rem + env(safe-area-inset-bottom))" }}
    >
      <div className="flex items-center gap-3">
        <p className="flex-1 text-[13px] font-semibold">
          A new version is ready.
        </p>
        <Button
          type="button"
          size="sm"
          className="rounded-lg font-bold"
          onClick={applyUpdate}
        >
          Reload
        </Button>
      </div>
    </div>
  );
}
